import React from "react";
import CustomTooltip from "./CustomTooltip";
import useSystemUser from "../hooks/useSystemUser";
import getDateAndTime from "../../Utils/getDateAndTime";

const UpdatedDetails = ({ record, truncate = false, className = "" }) => {
  const updatedByValue = record?.updatedBy || record?.updated_by;
  const updatedAtValue = record?.updatedAt || record?.updated_at;
  const updatedBy = useSystemUser(updatedByValue);
  const hasUpdatedBy = updatedByValue && updatedBy && updatedBy !== "--";
  const hasUpdatedAt = Boolean(updatedAtValue);
  const dateAndTime = hasUpdatedAt ? getDateAndTime(updatedAtValue) : null;

  if (!hasUpdatedAt && !hasUpdatedBy) {
    return <div className="text-xs font-semibold font-aileron text-dark-gray">--</div>;
  }

  let formattedDate = "--";
  if (dateAndTime) {
    formattedDate = truncate ? `${dateAndTime.substring(0, 15)}...` : dateAndTime;
  }

  return (
    <CustomTooltip tooltipTitle={dateAndTime ? `As on ${dateAndTime}` : "--"} placement="topLeft">
      <div className={className}>
        <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray capitalize">
          {hasUpdatedBy ? updatedBy : "--"}
        </div>
        <div className="text-10 font-light font-aileron leading-3.75 text-dark-gray">
          {formattedDate}
        </div>
      </div>
    </CustomTooltip>
  );
};

export default UpdatedDetails;
